module.exports = __webpack_public_path__ + "static/footer-bg-21805ba29581c880fb4f1265cee4013f.jpg";